import styles from './ProfileMenu.module.scss'
import useIsAuth from 'sdk/hooks/useIsAuth'
import useProfile from 'sdk/hooks/user/useProfile'
import { ReactComponent as IconUser } from 'images/user.svg';
import { useNavigate } from 'react-router-dom';
import ForwardArrow from '../UI/ForwardArrow';

const ProfileMenuButton = () => {
    const navigate = useNavigate()
    const { data: isAuthData } = useIsAuth()
    const isAuth = isAuthData?.isAuth
    const profileData = useProfile(isAuth)

    const handleProfleButton = () => {
        navigate('/profile')
    }

    return (
        <div className={styles.profile_button} onClick={handleProfleButton}>
            {profileData?.data?.avatar
                ? <img className={styles.profile_button__avatar} src={profileData?.data?.avatar} alt="Avatar Image" />
                : <IconUser />}
            <p>
                {profileData?.data?.username}
            </p>
            <div className={styles.profile_button__arrow}>
                <ForwardArrow />
            </div>
        </div>
    )
}

export default ProfileMenuButton